import React, { useState } from 'react';
import { Link } from 'gatsby';

import { download } from '../../utils/download';
import { IFooterLinks } from '../footer/helpers';

import { ScDropdowListContainer, ScDropdowListWrapper } from './styled';

export interface IDropdownItem {
	title: string;
	link: string;
	items: { title: string; link: string }[];
}

export const Dropdown = ({ item }: { item: IFooterLinks }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMouseLeave = () => {
		setAnchorEl(null);
	};

	return (
		<ScDropdowListWrapper
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			className="dropdown"
		>
			{item.link ? (
				<Link to={item.link} key={item.title}>
					{item.title}
				</Link>
			) : (
				item.title
			)}
			{open && item.group && (
				<div>
					<ScDropdowListContainer>
						{item.group.map((el) =>
							el.isItDownloadLink ? (
								<li key={el.title}>
									<button type="button" onClick={() => download(el.link)}>
										<span>{el.title}</span>
									</button>
								</li>
							) : (
								<li key={el.title}>
									<Link to={el.link}>
										<span>{el.title}</span>
									</Link>
								</li>
							),
						)}
					</ScDropdowListContainer>
				</div>
			)}
		</ScDropdowListWrapper>
	);
};
